<div class="modal">
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h3 class="card-title text-danger mb-0">{{ title }}</h3>
        <i class="fa fa-times pointer" (click)="closeModal()"></i>
      </div>
      <p>{{ message }}</p>
    </div>
    <div class="card-footer">
      <button class="btn btn-secondary btn-question" (click)="closeModal()">U redu</button>
    </div>
  </div>
</div>
